import FriendPage from "./FriendPage";

export const routes = [
    {
        path: "/user/:userId",
        component: FriendPage,
        exact: true,
        showNav: true
    }
]